/**
 * External dependencies
 */
import { Reducer } from 'redux';
import produce from 'immer';

/**
 * Internal dependencies
 */
import Account from '@naruto/bgdcms//src/reducers/stores/account';
import ACCOUNT_ACTION from '@naruto/bgdcms//src/reducers/cores/account/events';
import { CreateAccountReducerParams, AccountActionTypes } from './types';

export function createAccountReducer(params: CreateAccountReducerParams): Reducer<Account, AccountActionTypes> {
  return (state = params.initialState, action: AccountActionTypes): Account =>
    produce(state, _draft => {
      const draft = _draft;
      switch (action.type) {
        case ACCOUNT_ACTION.SET_ACCOUNT_INITIALIZE:
          draft.initialize();
          break;
        case ACCOUNT_ACTION.SET_ACCOUNT_LIST:
          draft.updateAccountList(action.list, action.condition);
          break;
        case ACCOUNT_ACTION.SET_ACCOUNT_INFO:
          draft.updateAccountInfo(action.accountID, action.accountInfo);
          break;
        default:
          break;
      }
    });
}
